import { useOnboarding } from '../onboarding-context'
import { OnboardingUserType } from '@super/shared-types'
import { BuilderEndingStep } from './BuilderEndingStep'
import { StandardEndingStep } from './StandardEndingStep'

export function DoneStep() {
  const { state } = useOnboarding()
  const isBuilder = state.userType === OnboardingUserType.SDK_BUILDER
  return isBuilder ? <BuilderEndingStep /> : <StandardEndingStep />
}
